import { useState } from 'react'

import type { LaptopHelperStep } from '../Steps/useLaptopQuestionSteps'

export const useLaptopHelperNavigation = (steps: LaptopHelperStep[]) => {
  const [currentPageIndex, setCurrentPageIndex] = useState(0)
  const [screenHistory, setScreenHistory] = useState([0])

  const next = () => {
    if (currentPageIndex === steps.length - 1) {
      return
    }
    const nextPage = currentPageIndex + 1
    setCurrentPageIndex(nextPage)
    setScreenHistory([...screenHistory, nextPage])
  }

  const back = () => {
    const previousPage = screenHistory[screenHistory.length - 2]
    if (previousPage !== undefined) {
      setCurrentPageIndex(previousPage)
      setScreenHistory(screenHistory.slice(0, -1))
    }
  }

  const goToLastPage = () => {
    if (currentPageIndex === steps.length - 1) {
      return
    }
    setCurrentPageIndex(steps.length - 1)
    setScreenHistory([...screenHistory, steps.length - 1])
  }

  const canGoBack = screenHistory.length > 1
  const canGoNext = currentPageIndex < steps.length - 1
  const isLastPage = currentPageIndex === steps.length - 1

  return {
    component: steps[currentPageIndex]?.component || null,
    trackingCallback: steps[currentPageIndex]?.trackingCallback,
    title: steps[currentPageIndex]?.title || `Step ${currentPageIndex + 1}`,
    next,
    back,
    canGoBack,
    canGoNext,
    isLastPage,
    goToLastPage,
  }
}
